export default __webpack_public_path__ + "static/B0242-a877f9584ccd6993f31acdf6f28a91aa.png";